/**
 * Initiates a file download in the browser.
 * @param {string} file - URL or path to the file to be downloaded.
 * @param {string} filename - Name for the downloaded file.
 */
export const handleFileDownload = (file, filename) => {
  const link = Object.assign(document.createElement('a'), {
    href: file,
    download: filename
  });
  document.body.append(link);
  link.click();
  link.remove();
};
